export const studyCalculators = [
  {
    name: "جدول تحويل المعدل التراكمي ",
    link: "/calculator/ar/gpatableconverter/",
    description:
      "تساعد هذه الحاسبة في تحويل المعدل التراكمي للطلاب إلى مقاييس مختلفة مثل GPA ونظام النسبة المئوية والمزيد.",
    showMain: true,
  },
  {
    name: "حساب المعدل الجامعي (التراكمي) ",
    link: "/calculator/ar/gpagrade/",
    description:
      "هذه الحاسبة تقوم بحساب المعدل الجامعي بناءً على النظام الدراسي الدولي.",
    showMain: true,
  },
  {
    name: "حاسبة المعدل التراكمي من 4",
    link: "/calculator/ar/gpa4/",
    description:
      "تستخدم هذه الحاسبة لحساب المعدل التراكمي بناءً على نظام التقدير من 4 نقاط.",
    showMain: true,
  },
  {
    name: "حاسبة المعدل التراكمي من 5",
    link: "/calculator/ar/gpa5/",
    description:
      "تقوم هذه الحاسبة بحساب المعدل التراكمي بناءً على نظام التقدير من 5 نقاط.",
    showMain: true,
  },
  {
    name: "حاسبة المعدل من 100",
    link: "/calculator/ar/grade100/",
    description:
      "هذه الحاسبة تقوم بتحويل المعدل من نظام التقدير إلى نظام المئة.",
    showMain: true,
  },
  {
    name: "حاسبة تخطيط المعدل التراكمي",
    link: "/calculator/ar/gpaplanner/",
    description:
      "تستخدم هذه الحاسبة لتخطيط المعدل التراكمي المستقبلي بناءً على الدرجات المتوقعة.",
    showMain: true,
  },
  {
    name: "تحويل المعدل من 100 إلى 4 وبالعكس",
    link: "/calculator/ar/grade100to4/",
    description:
      "تساعد هذه الحاسبة في تحويل المعدل من نظام المئة إلى نظام التقدير من 4 نقاط والعكس.",
  },
  {
    name: "تحويل المعدل التراكمي من 4 إلى 5 وبالعكس",
    link: "/calculator/ar/gpa4to5/",
    description:
      "تستخدم هذه الحاسبة لتحويل المعدل التراكمي بين نظامي التقدير من 4 نقاط و5 نقاط.",
  },
  {
    name: "تحويل المعدل التراكمي من 5 الى 100  ",
    link: "/calculator/ar/grade100to5/",
    description:
      "قم بتحويل معدل التراكمي بسهولة بين نظام 5 نقاط ونظام المئة. تعرّف على كيفية تحويل معدل التراكمي من 5 إلى 100 والعكس باستخدام هذه الأداة البسيطة.",
  },
  {
    name: "حاسبة الدرجات  ",
    link: "/calculator/ar/test-grade/",
    description: "احسب نسبة ودرجة اختبارك بسهولة باستخدام حاسبة الدرجات.",
  },
  {
    name: "تحويل المعدل إلى النظام البريطاني",
    link: "/calculator/ar/gradetouk/",
    description:
      "تقوم هذه الحاسبة بتحويل المعدل التراكمي إلى النظام البريطاني للتقدير.",
    showMain: true,
  },
  {
    name: "تحويل المعدل الجامعي إلى النظام الألماني",
    link: "/calculator/ar/gradetogerman/",
    description:
      "قم بتحويل معدلك الجامعي إلى النظام الألماني بسهولة ودقة. اعرف كيفية تحويل معدل البكالوريوس والماجستير إلى النظام الألماني باستخدام هذه الأداة المفيدة.",
  },
  {
    name: "تحويل المعدل الجامعي إلى النظام الفرنسي",
    link: "/calculator/ar/gradetofrench/",
    description:
      "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الفرنسي بسهولة ودقة. اعرف تفاصيل النظام الفرنسي للدرجات الجامعية.",
  },
  {
    name: "تحويل المعدل الجامعي إلى النظام الكندي",
    link: "/calculator/ar/gradetocanada/",
    description:
      "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الكندي بسهولة ودقة. اعرف تفاصيل النظام الكندي للدرجات الجامعية.",
  },
  {
    name: "تحويل المعدل الجامعي إلى نظام الدرجات الماليزي",
    link: "/calculator/ar/gradetomalaysia/",
    description:
      "تعلم كيفية تحويل معدلك التراكمي إلى نظام الدرجات الماليزي بسهولة وبدقة. تعرف على نظام الدرجات في الجامعات الماليزية.",
  },
  {
    name: "تحويل المعدل التراكمي إلى النظام التركي",
    link: "/calculator/ar/gradetoturkey/",
    description:
      "اكتشف كيفية تحويل معدلك الجامعي إلى النظام التركي بسهولة ودقة. اعرف تفاصيل النظام التركي للدرجات الجامعية.",
  },
  {
    name: "تحويل المعدل التراكمي إلى النظام الأسترالي",
    link: "/calculator/ar/gradetoaustralia/",
    description:
      "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الأسترالي بسهولة ودقة. اعرف تفاصيل النظام الأسترالي للدرجات الجامعية.",
  },
  {
    name: "حساب النسبة الموزونة",
    link: "/calculator/ar/weighted-percentage-calculator/",
    description:
      "حاسبة لحساب النسبة الموزونة بناءً على المعدل التراكمي ودرجة القدرات والتحصيلي.",
  },
];
export default studyCalculators;